import WeGlide from 'client/javascript/we_glide/we_glide';
import WeGlideWithThumbnails from 'client/javascript/we_glide/we_glide_with_thumbnails';
import { varsFromServer } from '../../client_side_injection_vars';

const MAIN_SLIDER_SELECTOR = '#building-page-slider';
const THUMBNAILS_SLIDER_SELECTOR = '#building-page-thumbnails-slider';
const AMENITIES_SLIDER_SELECTOR = '#building-page-amenities-slider';

export function setupSliders() {
  setupHeroSliderWithThumbnails();
  setupAmenitiesSlider();
}

function setupAmenitiesSlider() {
  const hasAmenitiesSlider = !!document.querySelector(AMENITIES_SLIDER_SELECTOR);

  if (hasAmenitiesSlider) {
    const glide = new WeGlide(AMENITIES_SLIDER_SELECTOR);
    glide.mount();
  }
}

function setupHeroSliderWithThumbnails() {
  const thumbnailsOverrides = {
    perView: varsFromServer.building.has_virtual_tour ? 6 : 8
  };

  const glide = new WeGlideWithThumbnails(MAIN_SLIDER_SELECTOR, THUMBNAILS_SLIDER_SELECTOR, {}, thumbnailsOverrides);
  glide.mount();
}
